<template>

    <v-flex xs12 sm6 md8 lg4 offset-sm3 offset-md2 offset-lg4 mt-5>
        <!-- Alert -->
        <Alert :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <v-container>

        <!--Change Password or Password Reset Form-->
            <v-card  class="semi-transparent-5-bg">

                <v-card-title style="border-bottom: 5px solid #3944bb" v-if="$route.name == 'Change Password'">
                    <img src="//assets.office4u.xyz/photos/BO-Demo/password-icon.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>
                    <div class="password-change-form-title">
                        <span>{{ $t( 'user_management.password_change').toUpperCase() }}</span>
                    </div>
                </v-card-title>

                <v-card-text>

                    <v-form ref="form" v-model="valid" lazy-validation>

                        <v-layout row class="margin-5-top-bottom">
                            <v-flex xs4>
                                <v-subheader class="inputlabel">{{ $t( 'user_management.old_pass' ) }}</v-subheader>
                            </v-flex>

                            <v-flex xs8 class="margin-16-right">
                                <v-text-field  id="oldPasswordField" v-model="oldPassword" class="oldPasswordField" :rules="passwordRules" single-line box required></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row class="margin-5-top-bottom">
                            <v-flex xs4>
                                <v-subheader class="inputlabel">{{ $t( 'user_management.new_pass' ) }}</v-subheader>
                            </v-flex>

                            <v-flex xs8 class="margin-16-right">
                                <v-text-field  id="newPasswordField" v-model="newPassword" class="newPasswordField" :rules="passwordRules" single-line box required></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row class="margin-5-top-bottom">
                            <v-flex xs4>
                                <v-subheader class="inputlabel">{{ $t( 'user_management.confirmed_pass' ) }}</v-subheader>
                            </v-flex>

                            <v-flex xs8 class="margin-16-right">
                                <v-text-field  id="confirmPassworddField" v-model="confirmPassword" class="confirmPassworddField" :rules="confirmPasswordRules" single-line box required></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row justify-center>

                            <v-btn class="mt-3" color="success" @click.prevent="validate" :disabled="!valid">
                                {{ $t( 'user_management.change') }}
                            </v-btn>

                            <v-btn class="mt-3" color="error" @click.prevent="$router.go(-1)">
                                {{ $t( 'user_management.back') }}
                            </v-btn>

                        </v-layout>

                    </v-form>

                </v-card-text>

            </v-card>

        </v-container>

    </v-flex>

</template>

<script>
import Alert from '@/components/Reusable/Alert.vue';
import Api from "@/api";

export default {
    name: 'PasswordChange',
    data() {
        return {
            valid: true,
            name: '',
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            alertType: "",
            message: "",
            visibility: "",
            progressbar: false,
        }
    },
    components: {
        Alert
    },
    computed : {
        confirmPasswordRules() {
            return [
                v => !!v || this.$t( 'user_management.confirm_pass_validation_rule' ),
                v => this.confirmPasswordCheck()
            ]
        },
        passwordRules() {
            return [
                v => !!v || this.$t( 'user_management.password_validation_rule' ),
                v => (v && v.length >= 6) || this.$t( 'user_management.pass_length_validation_rule' ),
            ]
        }
    },
    mounted(){

        $('input[type=text]').focus(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

           focusFormFieldAnimation(targetParentId);

        });

        $('input[type=text]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

         function focusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        }

        function unfocusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','');

            targetParentClass.css('box-shadow','');

            targetParentClass.css('transition-delay','');
        }

    },
    methods: {
        resetAlert() {
            this.visibility = false;
            this.message = "";
            this.alertType = "";
            this.progressbar = false;
        },
        async validate() {
            if (this.$refs.form.validate()) {
                this.resetAlert();
                let res = await Api.postChangePassword({
                    old_password: this.oldPassword,
                    password: this.newPassword,
                    password_confirmation: this.confirmPassword,
                    access_token: this.$store.getters.user_token
                });

                if (res && 'success' in res && res.success === true) {
                    this.visibility = true;
                    this.message = res.message;
                    this.alertType = "success";
                } else {
                    this.visibility = true;
                    this.message = res.message;
                    if (res.data) {
                        for (var oprop in res.data) {
                            this.message += '<br>' + res.data[oprop];
                        }
                    }
                    this.alertType = "error";
                    if(res.message == "token invalid") {
                        this.$store.dispatch('logout', res.data);
                        this.$router.push({name: 'login'})
                    }
                }
            }
        },
        confirmPasswordCheck() {
            return (this.newPassword === this.confirmPassword) || this.$t( 'user_management.passwords_match_validation_rule' );
        }
    }
}
</script>

<style scoped>
    .inputlabel {
        color: #4d4a4a;
        font-weight: bold;
    }

    .password-change-form-title{
        font-size: calc(1.0em + 0.5vmin);
        color: #3944bb;
    }
</style>
